// EP-59 — generic "รหัส" (code) field wording so the same auth flow
// works for both apartment tenants (RentalLease) and condo co-owners
// (OwnerContract). LIFF can't know account_type before login.
// 2026-10-01 (owner): the title names the lease code and says what the
// code is for; the field label and placeholder stay generic.
export default {
  lease_code_title: 'กรอกรหัสสัญญาเช่าเพื่อรับ OTP',
  lease_code_label: 'รหัส',
  lease_code_placeholder: 'เช่น AB123456',
  send_otp: 'ส่ง',
  otp_title: 'กรอก OTP',
  otp_subtitle: 'เราส่งรหัส 6 หลักไปที่',
  otp_label: 'รหัสยืนยัน',
  otp_expires: 'รหัสหมดอายุใน {{seconds}} วินาที',
  otp_expired: 'รหัสหมดอายุแล้ว',
  resend_otp: 'ส่ง OTP อีกครั้ง',
  verify_otp: 'ยืนยัน',
  lease_not_found: 'ไม่พบรหัส กรุณาตรวจสอบอีกครั้ง',
  otp_invalid: 'OTP ไม่ถูกต้องหรือหมดอายุแล้ว กรุณาลองอีกครั้ง',
  rate_limited: 'คำขอมากเกินไป กรุณารอสักครู่',
  no_phone: 'ไม่มีเบอร์โทรศัพท์ที่ลงทะเบียน กรุณาติดต่อเจ้าของที่พักหรือนิติบุคคล',
  account_unavailable: 'ที่พักนี้ยังใช้งานผ่านแอปไม่ได้ในขณะนี้ กรุณาติดต่อเจ้าของที่พักหรือนิติบุคคล',
  scan_qr_code: 'สแกน QR Code',
  scan_invalid_format: 'QR Code ไม่ถูกต้อง กรุณาสแกนรหัสที่ถูกต้อง',
  scan_permission_denied: 'ไม่ได้รับอนุญาตให้ใช้กล้อง กรุณาอนุญาตการเข้าถึงกล้อง',
  // EP-160 T160-103l: the privacy notice (PDPA s.23). A notice, not a consent.
  privacy_notice_title: 'ประกาศความเป็นส่วนตัว',
  privacy_notice_controller: '{{name}} เป็นผู้ควบคุมข้อมูลส่วนบุคคลของคุณ',
  privacy_notice_contact: 'ติดต่อ: {{contact}}',
  privacy_notice_processor: '{{processor}} เป็นผู้ประมวลผลข้อมูล',
  privacy_notice_policy_link: 'นโยบายความเป็นส่วนตัวของ FlowRent',
  privacy_notice_acknowledge: 'รับทราบ',
  privacy_notice_error: 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง',
}
